import Button from 'components/UI/Button/Button';
import Checkbox from 'components/UI/Checkbox/Checkbox';
import Modal from 'components/UI/Modal/Modal';
import { useRootModal } from 'hooks/useRootModal';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext, useState } from 'react';
import './ProjectLockModal.module.scss';
import { ReflectContext } from '../../Reflect';
import { OverviewContext } from '../../Views/Overview';

export default function ProjectLockModal() {
  const [isChecked, setIsChecked] = useState(false);
  const translate = useTranslate();

  const { closeModal } = useRootModal();

  // TODO: add unlock project mutation
  const { handleLockProject, handleUnlockProject } = useContext(ReflectContext);

  const { isRequested, setProjectModalIsOpen, isLockedProject } = useContext(
    OverviewContext
  );

  const handleClose = () =>
    setProjectModalIsOpen ? setProjectModalIsOpen(false) : closeModal();

  return (
    <Modal noCross setModalIsOpen={setProjectModalIsOpen} size="medium">
      <div styleName="wrapper">
        <div styleName="content">
          <div styleName="top">
            <h2>
              {!isRequested && isLockedProject
                ? 'Weet je zeker dat je dit project wilt ontgrendelen?'
                : 'Weet je zeker dat je het project op slot wil zetten?'}
            </h2>
            <p>
              Om een project te kunnen laten beoordelen moet deze op slot staan.
              Als je een project op slot zet kunnen jij en je eventuele
              groepsgenoten het project alleen nog maar bekijken.
            </p>
          </div>
          {!isRequested && isLockedProject ? null : (
            <div styleName="checkbox">
              <Checkbox isChecked={isChecked} setIsChecked={setIsChecked}>
                <p>
                  Alles is compleet. Zet het project voor mij en mijn
                  groepsgenoten op slot
                </p>
              </Checkbox>
            </div>
          )}
        </div>
        <div styleName="buttons">
          <Button color="grey" onClick={handleClose}>
            {translate('general.terms.cancel')}
          </Button>
          <Button
            onClick={() => {
              handleClose();
              if (!isRequested && isLockedProject) handleUnlockProject();
              else handleLockProject();
            }}
            inactive={isLockedProject ? false : !isChecked && !isRequested}
          >
            {!isRequested && isLockedProject
              ? 'Op slot zetten annuleren'
              : 'Project op slot zetten'}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
